// extracted by mini-css-extract-plugin
export default {"page":"OverviewPage_page__XQ1CO","goToIssuesPageButton":"OverviewPage_goToIssuesPageButton__RQDJB"};